import * as service from './service'
export default {
  namespace: 'customerServicePunishList',
  state: {
    demoData: {}
  },
  effects: {
    * queryCsPunishList ({ payload }, { call, put }) {
      const res = yield call(service.queryCsPunishList, payload)
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
